// extracted by mini-css-extract-plugin
module.exports = {"text-plain":"text-plain--i-7Ao"};